import axios from 'axios'
// import { setInetStatus } from './redux/actions/index'
// import store from './redux/store/index'

//Create a Http Client using Axios. Further modifications in this layer can be done later like Authorization.
// const WebServer = 'http://localhost/PaithaniShopping';
const WebServer = 'http://paithanishopping.com';
const WebServerGallery = WebServer + '/imgs/gallery/';

const post = (url = '', data = '', config = {}) => {
    return axios.post(WebServer + url, data, config)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            alert('no internet');
        });
}
const upload = (url = '', data = '', config = {}) => {
    
    const formData = new FormData()
    formData.set('file', data.img)
    formData.set('data', JSON.stringify(data.data))
    // config = {
    //     headers: {
    //         'content-type': 'multipart/form-data'
    //     }
    // }
    
    return axios.post(WebServer + url, formData, config)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error;
        })
}

const get = (url) => {
    return axios(WebServer + url).then(function(res){
        // console.log('setting');
            // store.dispatch(setInetStatus(false))
        return res.data
    })
    .catch(function(err){
        return err;
    })
}
/*
const put = (url = '', data = '', config = {}) => {
    return axios.put(url, data, config)
}

//Cannot contain a delete method - Cause delete is a keyword.

const del = (url = '', config = {}) => {
    return axios.delete(url, config)
}
*/

//Encapsulating in a JSON object
const HttpClient = {
    post,
    get,
    upload,
    WebServer,
    WebServerGallery
}

export default HttpClient


// WEBPACK FOOTER //
// ./src/myapi.js